import { Fragment } from 'react'
import styled from 'styled-components'

import { OBJ_BG_COLORS, STATUS } from '../../constants'
import { AdjustColumns, Hr } from '../../styles'
import Colors from '../../../../constants/Colors'
import { formatPrice } from '../../../../helpers/utils'

const OtherOrder = ({ otherOrders }) => {
  if (otherOrders?.length === 0) return false

  return (
    <Container>
      <Title>ยอดซื้ออื่นในรอบนี้</Title>
      {otherOrders?.map((v) => {
        const { id, orderId, totalPrice, status } = v
        return (
          <Fragment key={id}>
            <AdjustColumns>
              <div>เลขที่ใบสั่งซื้อ</div>
              <div>{orderId}</div>
            </AdjustColumns>
            <AdjustColumns>
              <div>ราคา</div>
              <div>{formatPrice(totalPrice)} บาท</div>
            </AdjustColumns>
            <AdjustColumns>
              <div>สถานะ</div>
              <StatusBadge bgColor={OBJ_BG_COLORS[status]}>{STATUS[status]}</StatusBadge>
            </AdjustColumns>
            <Hr />
          </Fragment>
        )
      })}
    </Container>
  )
}

export default OtherOrder

const Container = styled.div`
  margin-top: 5px;
  margin-bottom: 10px;
`
const Title = styled.h3`
  width: 100%;
  text-align: center;
  padding: 10px;
  background-color: ${Colors.LIGHT_GREY2};
`
const StatusBadge = styled.span`
  text-align: center;
  color: ${({ bgColor }) => bgColor};
`
